<template>
  <div class="step-item">
    <div
      class="step-item__number"
      v-html="imageSvg"
    />

    <div class="step-item__content">
      <div
        v-if="title"
        class="step-item__title"
        v-html="title"
      />

      <div
        class="step-item__description"
        v-html="description"
      />

      <div
        v-if="getTime()"
        class="step-item__date"
        v-html="getTime()"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepItem',

    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      imageSvg: {
        type: String,
        default: ''
      },
      dateEnd: {
        type: String,
        default: ''
      }
    },

    methods: {
      getTime () {
        if (this.dateEnd === null) return

        const month = ['Січня', 'Лютого', 'Березеня', 'Квітня', 'Травня', 'Червня', 'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня']

        const currentDate = Date.parse(new Date())
        const endDate = Date.parse(this.dateEnd)
        if (endDate <= currentDate) {
          return '<span class="step-item__time step-item__time_past"><svg width="18" height="14" viewBox="0 0 18 14" fill="none"><path d="M1.5 7.5L7 13L17 1.5" stroke="#4FCDB0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Виконано</span>'
        } else {
          return `<span class="step-item__time step-item__time_future">До ${new Date(this.dateEnd).getDate()} ${month[new Date(this.dateEnd).getMonth()]}</span>`
        }
      }
    }

  }
</script>

<style lang="scss">
.step-item {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 85px;

  @include mobile {
    padding-left: 56px;
  }

  &__number {
    margin-left: -85px;
    margin-bottom: -55px;

    @include mobile {
      margin-left: -57px;
      margin-bottom: -30px;
    }

    svg {
      @include mobile {
        width: 80px;
        height: 64px;
      }
    }
  }

  &__content {
    width: 100%;
    max-width: 333px;

    @include mobile {
      max-width: 187px;
    }
  }

  &__title {
    margin-bottom: 24px;

    @include mobile {
      margin-bottom: 12px;
    }

    p {
      font-size: 32px;
      font-weight: 700;
      line-height: 1.18;
      text-transform: uppercase;
      color: $c-medium-black;

      @include mobile {
        font-size: 18px;
        line-height: 24px;
      }
    }
  }

  &__description {
    width: 100%;
    max-width: 309px;
    font-size: 24px;
    line-height: 1.34;
    color: $c-black;

    @include mobile {
      font-size: 18px;
      line-height: 24px;
    }
  }

  &__date {
    margin-top: 22px;

    @include mobile {
      margin-top: 8px;
    }
  }

  &__time {
    font-size: 18px;
    line-height: 1.34;
    color: $c-orange;

    @include mobile {
      font-size: 13px;
      line-height: 1.34;
    }

    svg {
      margin-right: 20px;

      @include mobile {
        margin-right: 4px;
        width: 9px;
        height: 6px;
      }
    }

    &_past {
      color: $c-green;
    }
  }
}
</style>
